import colors from "assets/colors";
import {
  ClassIDState,
  ClassStudentsState,
  SchoolClassesState,
  StudentIDState,
} from "global-states";
import { FC, useMemo, useState } from "react";
import { CSSProperties } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";

import AIHelpImage from "assets/ai_help.jpeg";
import DashboardHelpImage from "assets/dashboard_help.jpeg";
import PerformanceHelpImage from "assets/performance_help.jpeg";

// Components
import {
  Header,
  Container,
  Dropdown,
  DropdownProps,
  Button,
  Icon,
} from "semantic-ui-react";

const DashboardContainerStyle: CSSProperties = {
  background: colors.pageBackground,
  height: "100%",
  padding: "2em",
  overflow: "auto",
};

const SubHeaderStyle: CSSProperties = {
  color: colors.darkBlue,
  fontSize: "1.8rem",
  flex: 1,
  margin: 0,
  marginBottom: 0,
};

const HeaderContainerStyle: CSSProperties = {
  display: "flex",
  marginBottom: "1.5em",
};

const PageContainer: FC<{ title: string; showDropdown?: boolean }> = (
  props
) => {
  const { children, title, showDropdown } = props;
  const location = useLocation();
  const [isShowHelp, setIsShowHelp] = useState(false);
  const classes = useRecoilValue(SchoolClassesState);
  const students = useRecoilValue(ClassStudentsState);
  const [classID, setClassID] = useRecoilState(ClassIDState);
  const [studentID, setStudentID] = useRecoilState(StudentIDState);

  const classesOptions = classes.map((cls) => ({
    key: cls.class_id,
    text: cls.class_name,
    value: cls.class_id,
  }));
  const studentsOptions = students.map((std) => ({
    key: std.student_id,
    text: std.student_name,
    value: std.student_id,
  }));

  function onClassChange(_: any, d: DropdownProps) {
    if (!d.value) return;
    setClassID(d.value as string);
    setStudentID("" as string);
  }

  function onStudentChange(_: any, d: DropdownProps) {
    if (!d.value) return;
    setStudentID(d.value as string);
  }

  function onShowHelp() {
    setIsShowHelp(true);
  }

  function onHideHelp() {
    setIsShowHelp(false);
  }

  const pageHelperImageSrc = useMemo(() => {
    if (location.pathname.includes("performance")) {
      return PerformanceHelpImage;
    } else if (location.pathname.includes("integration")) {
      return AIHelpImage;
    } else {
      return DashboardHelpImage;
    }
  }, [location.pathname]);

  return (
    <Container fluid style={DashboardContainerStyle}>
      <div style={HeaderContainerStyle}>
        <Header style={SubHeaderStyle}>{title}</Header>
        {showDropdown && (
          <div>
		  
            學生: &nbsp;
            <Dropdown
              options={studentsOptions}
              onChange={onStudentChange}
              value={studentID}
              style={{ minWidth: 100 }}
              placeholder={"學生"}
            />
          </div>
        )}
        <span style={{ position: "relative" }}>
          <Button
            icon
            style={{
              height: "1.5em",
              width: "1.5em",
              padding: 0,
              backgroundColor: "inherit",
            }}
            onMouseOver={onShowHelp}
            onMouseLeave={onHideHelp}
          >
            <Icon name="help" color="yellow" style={{ fontSize: "12px" }} />
          </Button>
          {isShowHelp && (
            <img
              src={pageHelperImageSrc}
              alt="Helper"
              style={{
                position: "absolute",
                zIndex: 9,
                top: "1.5em",
                right: "1.5em",
                width: 900,
                boxShadow: "0 1px 2px #ccc",
              }}
            />
          )}
        </span>
      </div>
      {children}
    </Container>
  );
};

export default PageContainer;
